export enum ProfessionalCategoryEnum {
	MEDIC_GENERIC = "2231", // Médico gênero genérico
	MEDIC = "2251", // Médicos clínicos
	MEDIC_SURGEON = "2252", // Médicos em especialidades cirúrgicas
	MEDIC_PHYSICIAN = "2253", // Médicos em medicina diagnóstica e terapêutica
	NURSE = "2235", // Enfermeiro
	DENTIST = "2232", // Dentista
	NURSING_TECHNICIAN = "3222", // Técnico de enfermagem
}
